import { defineMessages } from 'react-intl'

export default defineMessages({
  email: 'Please send us your application via email to',
  btn: 'What do I need?'
})
